// imports
import axios from 'axios'
import { useEffect, useState } from 'react'

import { AREAS_API, DISTRICTS_API, DIVISIONS_API, ORGANIZATIONS_API, SUBCATEGORIES_API } from '../../../../../Utilities/APIs'

import Form from '../../../../Partials/Layouts/Forms/Form'
import ImageInput from '../../../../Partials/Layouts/Forms/FormInputs/ImageInput/ImageInput'
import LongTextInput from '../../../../Partials/Layouts/Forms/FormInputs/LongTextInput/LongTextInput'
import SelectInput from '../../../../Partials/Layouts/Forms/FormInputs/SelectInput/SelectInput'
import SelectOption from '../../../../Partials/Layouts/Forms/FormInputs/SelectInput/SelectOption/SelectOption'
import ShortTextInput from '../../../../Partials/Layouts/Forms/FormInputs/ShortTextInput/ShortTextInput'
import FormSubmitButton from '../../../../Partials/Layouts/Forms/FormSubmitButton/FormSubmitButton'

function CreateItem({

    employee, setShowCreateForm, setShowModal, triggerFetch

}) {

    // useStates
    const [subcategory, setSubcategory] = useState('initial')
    const [name, setName] = useState('')
    const [engName, setEngName] = useState('')
    const [description, setDescription] = useState('')
    const [engDescription, setEngDescription] = useState('')
    const [cost, setCost] = useState(0)
    const [coverImage, setCoverImage] = useState('')
    const [cardImage, setCardImage] = useState('')
    const [headOfficeArea, setHeadOfficeArea] = useState('')

    const [selectedDivision, setSelectedDivision] = useState('')
    const [selectedDistrict, setSelectedDistrict] = useState('')

    const [divisions, setDivisions] = useState(null)
    const [districts, setDistricts] = useState(null)
    const [areas, setAreas] = useState(null)

    const [subcategories, setSubcategories] = useState(null)

    // useEffects
    useEffect(() => {

        const config = {
            headers: {
                Authorization: `Bearer ${employee.token}`
            }
        }

        async function getAndSetSubcategories() {
            const {data} = await axios.get(SUBCATEGORIES_API, config)
            setSubcategories(data)
        }

        getAndSetSubcategories()


    }, [employee.token, setSubcategories])

    useEffect(() => {
        async function getAndSetDivisions() {
            const {data} = await axios.get(DIVISIONS_API)
            setDivisions(data)
        }

        getAndSetDivisions()
    }, [])

    useEffect(() => {
        if (selectedDivision !== '') {
            async function getAndSetDistricts() {
                const {data} = await axios.get(DISTRICTS_API + 'getDistrictsFromDivision/' + selectedDivision)
                setDistricts(data)
            }
            getAndSetDistricts()
        }
    }, [selectedDivision])

    useEffect(() => {
        if (selectedDistrict !== '') {
            async function getAndSetAreas() {
                const {data} = await axios.get(AREAS_API + 'getAreasFromDistrict/' + selectedDistrict)
                setAreas(data)
            }
            getAndSetAreas()
        }
    }, [selectedDistrict])

    async function handleSubmit(e) {

        e.preventDefault()

        const config = {
            headers: {
                Authorization: `Bearer ${employee.token}`
            }
        }

        const itemData = new FormData()

        itemData.append('subcategory', subcategory)
        itemData.append('name', name)
        itemData.append('engName', engName)
        itemData.append('description', description)
        itemData.append('engDescription', engDescription)
        itemData.append('cost', cost)
        itemData.append('cardImage', cardImage)
        itemData.append('coverImage', coverImage)
        itemData.append('headOfficeArea', headOfficeArea)
        
        console.log(itemData)

        const response = await axios.post(ORGANIZATIONS_API, itemData, config)

        if (response) {
            setSubcategory('')
            setName('')
            setDescription('')
            setCost(0)
            setCardImage('')
            setCoverImage('')

            setShowCreateForm(false);
            setShowModal(false);
            console.log(response)
            triggerFetch()
        }

    }

    return (
        <Form onSubmit={handleSubmit} hasImage>
            <SelectInput value={subcategory} setState={setSubcategory}>
                <SelectOption optionValue={'initial'} optionText={'Select Subcategory'} />
                {subcategories?.map(sc => (
                    <SelectOption key={sc._id} optionValue={sc._id} optionText={sc.name} />
                ))}
            </SelectInput>
            <ShortTextInput
                label={`Bangla Name`}
                value={name}
                placeholder={`Enter Bangla Name`}
                setState={setName}
            />
            <ShortTextInput
                label={`English Name`}
                value={engName}
                placeholder={`Enter English Name`}
                setState={setEngName}
            />
            <LongTextInput
                label={`Bangla Description`}
                value={description}
                placeholder={`Enter Bangla Description`}
                setState={setDescription}
            />
            <LongTextInput
                label={`English Description`}
                value={engDescription}
                placeholder={`Enter English Description`}
                setState={setEngDescription}
            />
            
            <SelectInput value={cost} setState={setCost}>
                <SelectOption optionValue={0} optionText='Select Cost' />
                <SelectOption optionValue={1} optionText={1} />
                <SelectOption optionValue={2} optionText={2} />
                <SelectOption optionValue={3} optionText={3} />
            </SelectInput>
            
            <ImageInput fieldId='1' state={cardImage} setState={setCardImage} allowCreateImage>Upload Card Image</ImageInput>

            <ImageInput fieldId='2' state={coverImage} setState={setCoverImage} allowCreateImage>Upload Cover Image</ImageInput>

            <SelectInput value={selectedDivision} setState={setSelectedDivision}>
                <SelectOption optionValue={''} optionText={'Select Division'} />
                {divisions?.map(division => (
                    <SelectOption key={division._id} optionValue={division._id} optionText={division.name} />
                ))}         
            </SelectInput>

            {
                selectedDivision && selectedDivision !== '' && 
                <SelectInput value={selectedDistrict} setState={setSelectedDistrict}>
                    <SelectOption optionValue={''} optionText={'Select District'} />
                    {districts?.map(district => (
                        <SelectOption key={district._id} optionValue={district._id} optionText={district.name} />
                    ))}         
                </SelectInput>
            }        
            
            {
                selectedDistrict && selectedDistrict !== '' && 
                <SelectInput value={headOfficeArea} setState={setHeadOfficeArea}>
                    <SelectOption optionValue={''} optionText={'Select Head Office Area'} />
                    {areas?.map(area => (
                        <SelectOption key={area._id} optionValue={area._id} optionText={area.name} />
                    ))}         
                </SelectInput>
            }        
            
            <FormSubmitButton text='Create Organization' />
        </Form>
    )
}

export default CreateItem